export default __webpack_public_path__ + "static/media/ca_6.f2461aae.png";